import { Theme, createTheme } from '@mui/material/styles';

const baseTheme = createTheme({
  palette: {
    primary: {
      main: '#2196f3',
    },
    secondary: {
      main: '#689f38',
    },
  },
});

// default desktop
const desktopTheme = (theme: Theme) =>
  createTheme({
    ...theme,
    components: {
      MuiOutlinedInput: {
        defaultProps: {
          size: 'medium',
        },
      },
      MuiInputLabel: {
        defaultProps: {
          size: 'normal',
        },
      },
      MuiButton: {
        defaultProps: {
          size: 'medium',
        },
      },
      MuiIconButton: {
        defaultProps: {
          size: 'medium',
        },
      },
      MuiChip: {
        defaultProps: {
          size: 'medium',
        },
      },
      MuiSwitch: {
        defaultProps: {
          size: 'medium',
        },
      },
      MuiButtonGroup: {
        defaultProps: {
          size: 'medium',
        },
      },
    },
  });

// mostly for mobile
const denseTheme = (theme: Theme) =>
  createTheme({
    ...theme,
    components: {
      MuiOutlinedInput: {
        defaultProps: {
          size: 'small',
        },
      },
      MuiInputLabel: {
        defaultProps: {
          size: 'small',
        },
      },
      MuiButton: {
        defaultProps: {
          size: 'small',
        },
      },
      MuiIconButton: {
        defaultProps: {
          size: 'small',
        },
      },
      MuiChip: {
        defaultProps: {
          size: 'small',
        },
      },
      MuiSwitch: {
        defaultProps: {
          size: 'small',
        },
      },
      MuiButtonGroup: {
        defaultProps: {
          size: 'small',
        },
      },
    },
  });

export { baseTheme, desktopTheme, denseTheme };
